import React from 'react'
import { Form, FormGroup, FormFeedback, Row, Col, Button } from 'reactstrap';
import { FaUserAlt, FaLock } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory, useLocation } from 'react-router';
import { NavLink } from 'react-router-dom'

import logo from '../image/login-icon.png';
import ErrorSwal from '../components/SwalError'

import { LoginAPI, UserProfile } from '../components/functions/LoginPage';

import { updateProfile } from '../components/redux/actions/authAction'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'



const schema = yup.object().shape({
    username: yup
        .string()
        .required("Please enter your Username"),
    password: yup
        .string()
        .required("Please enter your Password")
        .min(6, "The minimum entered is 6 or more."),
})


const Login = () => {
    const { t } = useTranslation()

    //call redux action
    const dispatch = useDispatch();

    const history = useHistory();
    let location = useLocation();

    let { from } = location.state || { from: { pathname: "/dashboard" } };

    const [error, setError] = React.useState(null);

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    const checkIsLogin = () => {
        if (localStorage.getItem('profile')) {
            history.replace(from)
        }
    }


    const onSubmit = async (data) => {

        try {

            // const response = await LoginAPI2(data)
            // .then(response => response.text(),2222)
            // .then(result => console.log(result,1111))
            // .catch(error => console.log('error', error));
            // const data = await response.json();
            // console.log(data.access_token)

            const resp = await LoginAPI(data)

            localStorage.setItem("token", JSON.stringify(resp.data))
            const Token = JSON.parse(localStorage.getItem("token"))
            // console.log(Token,Token.access_token);
            // get Profile
            const resProfile = await UserProfile(Token.access_token)
            localStorage.setItem("profile", JSON.stringify(resProfile.data.employee))
            // console.log(resProfile)
            const profileValue = JSON.parse(localStorage.getItem('profile'))

            dispatch(updateProfile(profileValue))

            // console.log(profileValue.FIRST_LOGIN )
            ErrorSwal({ title: 'Signed in successfully', text: 'Signed in successfully', icon: 'success' })
            
            if (profileValue.FIRST_LOGIN === '0') {
                if(from.pathname === '/settings'){
                    history.replace("/dashboard");
                    history.go("0");
                }
                else{
                   
                  
                    history.push(from);
                    // history.replace(from);
                    // history.go(from);
                    history.go("0");
                    // history.replace(from);
  
                }
              
            }
            else{
                history.replace("/settings");
            }

          


        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }
    }

    React.useEffect(() => {
        checkIsLogin()
    })

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    return (
        <>
            <div id="auth" style={{ backgroundColor: 'white' }}>

                <Row className="row h-100">
                    <Col lg={5} >
                        <div id="auth-left">
                            <div className="auth-logo">
                                <img src={logo} alt="Logo" srcSet="" />
                            </div>

                            <h1 className="auth-title">{t('t_login')}</h1>

                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup className="mb-4 position-relative has-icon-left" >
                                    <div className="form-control-icon">
                                        <FaUserAlt size='2em' />
                                    </div>
                                    <input
                                        type="text"
                                        name="username"
                                        ref={register}
                                        className={`form-control-xl form-control ${errors.username ? "is-invalid" : ""}`}
                                        placeholder={t('i_user')}
                                    />
                                    {errors.username && (
                                        <FormFeedback type="invalid">
                                            {errors.username.message}
                                        </FormFeedback>
                                    )}
                                </FormGroup>
                                <FormGroup className="mb-4 position-relative has-icon-left" >
                                    <div className="form-control-icon">
                                        <FaLock size='2em' />
                                    </div>
                                    <input
                                        type="password"
                                        name="password"
                                        ref={register}
                                        className={`form-control-xl form-control ${errors.password ? "is-invalid" : ""}`}
                                        placeholder={t('i_pass')}
                                    />

                                    {errors.password && (
                                        <FormFeedback type="invalid">
                                            {errors.password.message}
                                        </FormFeedback>
                                    )}
                                </FormGroup>


                                <Button color="primary" type="submit" className="mt-5 shadow-lg btn btn-primary btn-block btn-lg">
                                    {t('b_login')}
                                </Button>
                            </Form>
                            <div className="mt-5 text-lg text-center fs-4">

                                <p className="text-gray-600"> {t('t_do_not_login')}
                                    <NavLink to="/forget-password" className="font-bold">
                                        {t('t_reset_pass')}
                                    </NavLink>
                                </p>

                            </div>
                        </div>
                    </Col>
                    <Col lg={7} className="d-none d-lg-block">
                        <div id="auth-right">
                        </div>
                    </Col>


                </Row>
            </div>
        </ >
    )
}

export default Login;
